import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import { classNames } from "helpers/commonHelpers";
// import ActiveDropdown from "./ActiveDropdown";
import NavContext from "./NavContext";

interface MobileNavigationProps {
  navigation: React.RefObject<HTMLSelectElement>;
  hideButton?: boolean;
}

const MobileNavigation = function ({ navigation, hideButton = false }: MobileNavigationProps) {
  const [scrolled, setScrolled] = useState<boolean>(false);
  const { navigationConfig, setNavigationConfig } = useContext(NavContext);

  // Handles clicking outside of the mobile menu
  useEffect(() => {
    const handleClickOutside = (event: any) => {
      if (!navigationConfig.isShown) return;
      if (event.target.tagName === "BUTTON") {
        event.target.click();
        setNavigationConfig({ ...navigationConfig, expanded: false, isShown: false });
        return;
      }
      if (navigation.current && !navigation.current.contains(event.target))
        if (navigationConfig.expanded && navigationConfig.isShown)
          setNavigationConfig({ ...navigationConfig, expanded: false, isShown: false });
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [navigationConfig.isShown]);

  // Set active dropdown label
  // useEffect(() => {
  //   if (document.location.pathname.includes("/shipment/tracking/")) setActiveDropdown("Tracking");
  //   else if (document.location.pathname.includes("/shipment/detail/")) setActiveDropdown("Shipment Details");
  //   else if (document.location.pathname.includes("/shipment/billing/")) setActiveDropdown("Billing");
  //   else if (document.location.pathname.includes("/shipment/audit-trail")) setActiveDropdown("Audit Trail");
  //   else if (document.location.pathname.includes("/quick/")) setActiveDropdown("Quick");
  //   else if (document.location.pathname.includes("/shipment/")) setActiveDropdown("Quote");
  //   else if (document.location.pathname.includes("/quick/detail/")) setActiveDropdown("Quick Details");
  //   else setActiveDropdown("");
  // }, [document.location.pathname]);

  // Create sticky nav when scrolling down
  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 15);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const showNavigation = () =>
    setNavigationConfig({
      ...navigationConfig,
      expanded: true,
      isShown: true,
    });

  return (
    <div
      className={classNames("mobile-navigation hide-during-print", {
        "mobile-navigation--hidden": hideButton,
        "sticky-nav fixed-top": scrolled && !hideButton,
        "d-flex align-items-center ml-4xl mt-3xl": !hideButton,
      })}
    >
      {!hideButton && (
        <button type="button" className="mobile-navigation__menu-btn" onClick={showNavigation} aria-label="Open menu">
          <FontAwesomeIcon icon={faBars} />
        </button>
      )}
      {/* @ts-ignore */}
      {/*
        Commented this dropdown, because now normal NavPills
        is responsive and will render in case of mobile as well 
      */}
      {/* {activeDropdown ? <ActiveDropdown activeDropdown={activeDropdown} /> : null} */}
      {navigationConfig.isShown && <div className="screen-darken" />}
    </div>
  );
};

MobileNavigation.propTypes = {
  navigation: PropTypes.instanceOf(Object),
  hideButton: PropTypes.bool,
};

MobileNavigation.defaultProps = {
  navigation: {},
  hideButton: false,
};

export default MobileNavigation;
